import React, { useState, useEffect, useMemo } from 'react'
import WebMain from './WebMain'
import { useGwGoodsListQuery, useGwGoodsTypeSubListQuery, useReadnumAddMutation } from '../store/ReactWebSiteApi';
import { Card,Menu, Radio,Flex } from 'antd';
import { DollarOutlined, ShoppingCartOutlined, UnorderedListOutlined, TeamOutlined, FileOutlined, DesktopOutlined, FileSyncOutlined, DatabaseOutlined, EyeOutlined   } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import ReactWebSiteApi from '../store/ReactWebSiteApi'
import styles from './WebGoods.module.css'

const { Meta } = Card;
/** 与空字符串不同，antd Menu 对 key 为 '' 时 selectedKeys 高亮不可靠 */
const MENU_KEY_ALL = '__all__'
const items = [
    {
        label: '全部类型',
        key: MENU_KEY_ALL,
        icon: <UnorderedListOutlined />,
    },
    {
        label: '记账管理',
        key: '4',
        icon: <DollarOutlined />,
    },
    {
        label: '销售管理',
        key: '7',
        icon: <ShoppingCartOutlined />,
    },
    {
        label: '人事管理',
        key: '8',
        icon: <TeamOutlined />,
    },
    {
        label: '行政管理',
        key: '9',
        icon: <FileOutlined />,
    },
    {
        label: '办公管理',
        key: '10',
        icon: <DesktopOutlined />,
    },
    {
        label: '合同管理',
        key: '12',
        icon: <FileSyncOutlined />,
    },
    {
        label: '物品管理',
        key: '11',
        icon: <DatabaseOutlined />,
    },
    {
        label: '客户管理',
        key: '13',
        icon: <TeamOutlined />,
    },
]
const ALLOWED_EOWGT_IDS = new Set(
    items.filter((i) => i.key !== MENU_KEY_ALL).map((i) => String(i.key))
)
function WebGoods() {
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()
    /** 列表请求参数：完全由 URL 查询串推导，避免与 searchParams 双份维护 */
    const query = useMemo(() => {
        const rawType = searchParams.get('eowgt_id') ?? ''
        const eowg_type_id =
            rawType && ALLOWED_EOWGT_IDS.has(String(rawType)) ? String(rawType) : ''
        return {
            eowg_e_id: '218',
            eowg_type_id,
            eowg_sub_type_id: searchParams.get('eowgts_id') ?? '',
        }
    }, [searchParams])
    const menuSelectedKeys = useMemo(
        () => [query.eowg_type_id ? query.eowg_type_id : MENU_KEY_ALL],
        [query.eowg_type_id]
    )
    const {data,isSuccess} = useGwGoodsListQuery(query,{refetchOnMountOrArgChange:1})
    const [list, setList] = useState([]);
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const raw = Array.isArray(data.Result) ? data.Result : []
                const arr = [...raw].sort((a, b) => {
                    return +a.eowg_serial_number - +b.eowg_serial_number;
                })
                setList(arr.filter(item => item.eowg_state === '1'))
            }else{
                setList([])
            }
        }
    }, [data, isSuccess])
    //获取子类型
    const [sonTypeList, setSonTypeList] = useState([]);
    const {data:sonTypeData,isSuccess:isSuccessSonType} = useGwGoodsTypeSubListQuery({eowgt_id:query.eowg_type_id},{refetchOnMountOrArgChange:1})
    useEffect(() => {
        if(isSuccessSonType){
            if(sonTypeData.Status==='success'){
                const arr = [{
                    label: '全部企业',
                    value: ''
                },...sonTypeData.Result.map(item => ({
                    label: item.eowgts_name,
                    value: item.eowgts_id
                }))]
                setSonTypeList(arr)
            }else{
                setSonTypeList([])
            }
        }
           
        }, [sonTypeData, isSuccessSonType])    
    //增加阅读次数
    const [submitReadnumAdd] = useReadnumAddMutation()
  
    return (
        <WebMain selectedKeys='goods'>
            <div
                style={{display:'flex',gap:'20px'}}
            >
                <div style={{width:'200px'}}>
                    <Menu
                        items={items}
                        mode='vertical'
                        theme='light'
                        onClick={(e) => {
                            setSearchParams((prev) => {
                                const next = new URLSearchParams(prev)
                                const key = e.key == null ? MENU_KEY_ALL : String(e.key)
                                if (key === MENU_KEY_ALL) next.delete('eowgt_id')
                                else next.set('eowgt_id', key)
                                next.delete('eowgts_id')
                                return next
                            })
                        }}
                        style={{width:'100%',fontSize:'18px'}}
                        selectedKeys={menuSelectedKeys}
                    />
                </div>
                <div>
                    {searchParams.get('eowgts_id') && (<div style={{margin:'20px 0'}}>
                        <Radio.Group 
                            optionType='button' 
                            buttonStyle='solid' 
                            value={query.eowg_sub_type_id} 
                            onChange={(e) => {
                                setSearchParams((prev) => {
                                    const next = new URLSearchParams(prev)
                                    const sub = e.target.value
                                    if (sub) next.set('eowgts_id', sub)
                                    else next.delete('eowgts_id')
                                    return next
                                })
                            }}
                            options={sonTypeList}
                        />
                    </div>)}
                    <div style={{padding:'30px',alignItems:'center',justifyContent:'flex-start',display:'flex',flexWrap:'wrap',gap:'20px',width:'100%'}}>
                    {list.map(item => (
                        <Card 
                            key={item.eowg_id}
                            className={styles.goodsCard}
                            onMouseEnter={() => {
                                const id = item.eowg_id
                                if (!id) return
                                dispatch(ReactWebSiteApi.util.prefetch('gwGoodsUpdate', { eowg_id: id }, { force: false }))
                                dispatch(ReactWebSiteApi.util.prefetch('gwGoodsGuigeList', { eowgg_eowg_id: id }, { force: false }))
                            }}
                            cover={
                                <img
                                    draggable={false}
                                    alt="example"
                                    src={`../api/assets/images/application/${item.eowg_image_file.split(',')[0]}`}
                                    style={{width: '300px', height: '300px', objectFit: 'cover', display: 'block'}}
                            
                                />
                            }
                            onClick={() => {
                                submitReadnumAdd({eowg_id:item.eowg_id})
                                navigate(`/WebGoodsSubTypeGoodsDesc?eowg_id=${item.eowg_id}`)
                            }}
                        >
                        <Meta
                            title={
                                <div className={styles.goodsCardTitle}>
                                    {item.eowg_name}
                                </div>
                            }
                            description={
                                <Flex justify='space-between' align='center'>
                                    <div><EyeOutlined /> {item.read_num}</div>
                                    <div
                                        style={{
                                        fontSize:'16px',
                                        color:'#ff4d4f',
                                        fontWeight:'bold',
                                        }}
                                    >
                                        ￥<span style={{fontSize:'24px'}}>{item.price}</span>
                                    </div>
                                </Flex>
                            }
                        />
                
                        </Card>
                    ))}
                
                </div>
                </div>
            </div>

        </WebMain>
    )
}

export default WebGoods